import React from 'react';
import Loadable from 'react-loadable';
import PropTypes from 'prop-types';
import * as Utils from './utils';
import * as Constants from './TimesConstants';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'WithCovid19SubscriptionWdt' */ './WithCovid19SubscriptionWdt'),
  loading: () => null,
  // delay: 2000,
});

export default class Covid19SubscriptionWdtLoader extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
    // this.setState({});
    const wdtExpiry = parseInt(
      Utils.getLocalStorage(Constants.WDT_EXPIRY_KEY) || '',
      10,
    );
    const currentTimestamp = new Date().getTime();
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(wdtExpiry) && currentTimestamp < wdtExpiry) {
      this.props.setFallback(true);
      return;
    }
    setTimeout(() => {
      this.setState({ load: true });
    }, 2000);
  }
  render() {
    if (!this.state.load) {
      return null;
    }
    return <LoadableComponent {...this.props} />;
  }
}
Covid19SubscriptionWdtLoader.propTypes = {
  setFallback: PropTypes.func,
};
Covid19SubscriptionWdtLoader.defaultProps = {
  setFallback: () => {},
};
